export const ADMIN_ACCOUNT_INFO = 'ADMIN_ACCOUNT_INFO';
export const ADMIN_ACCOUNT_INFO_LOADING = 'ADMIN_ACCOUNT_INFO_LOADING';
